export const pagination = {
  rowsPerPage: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
};
export function generatePagination(currentPage, totalPages, maxVisible = 5) {
  const pagination = [];
  const firstPage = 1;
  const lastPage = totalPages;

  if (totalPages <= maxVisible) {
    for (let i = 1; i <= totalPages; i++) {
      pagination.push(i);
    }
  } else {
    pagination.push(firstPage);

    let startPage = Math.max(2, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (startPage > 2) {
      pagination.push({
        type: "ellipsis",
        value: Math.max(1, currentPage - 5),
      });
    }

    for (let i = startPage; i <= endPage; i++) {
      pagination.push(i);
    }

    if (endPage < totalPages - 1) {
      pagination.push({
        type: "ellipsis",
        value: Math.min(totalPages, currentPage + 5),
      });
    }

    pagination.push(lastPage);
  }

  return pagination;
}
